import { createFileRoute, redirect } from '@tanstack/react-router';
import { ADMIN_SYSTEM_MONITOR_RUN_DETAIL } from '@/lib/constants/routes';

/**
 * Link vecchio del dettaglio job (pagina intera): il dettaglio ora è la sheet
 * sopra la lista delle esecuzioni, sulla rotta `runs/$id`.
 */
export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/job/$jobId'
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: ADMIN_SYSTEM_MONITOR_RUN_DETAIL,
      params: { id: params.jobId },
      search,
      replace: true,
    });
  },
});
